import { render, staticRenderFns } from "./AddTodoAPI.vue?vue&type=template&id=043acceb&scoped=true&"
import script from "./AddTodoAPI.vue?vue&type=script&lang=js&"
export * from "./AddTodoAPI.vue?vue&type=script&lang=js&"
import style0 from "./AddTodoAPI.vue?vue&type=style&index=0&id=043acceb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043acceb",
  null
  
)

export default component.exports